import LeadgenModal from "./leadgen-modal";
import {parsePhoneNumber, isValidPhoneNumber} from 'libphonenumber-js'

const BLOCCA_OFFERTA_LEADGEN_MODAL = {
    ID: '#blocca-offerta-leadgen-modal',
    STEP_CONTAINER: '.leadgen-modal-step-container',
    LOGIN_FORM: '#form-signin',
    CLOSE: '.leadgen-close',
    SAVE_BUTTON: '.leadgen-save',
    BACK_BUTTON: '.leadgen-save-back',
    LOGIN_BUTTON: '.modal-login-step',
    CLOSE_BUTTON: '.btn-close',
    CHECK_INPUT: '.form-check-input',
    TRIGGER: 'leadgen-modal-trigger',
    EMAIL_FEEDBACK_INPUT: {
        EMAIL: 'div[data-validated="id_email"]',
        LOGIN: 'div[data-validated="id_login"]',
        CONFIRMATION: 'div[data-validated="id_email_confirmation"]'
    },
    PASSWORD_FEEDBACK_INPUT: {
        LOGIN: 'div[data-validated="id_password"]',
        PASSWORD: 'div[data-validated="id_password1"]',
        CONFIRMATION: 'div[data-validated="id_password_confirmation"]'
    },
    INVALID_FEEDBACK: '.invalid-feedback'
}

class BloccaOffertaLeadgenModal extends LeadgenModal {
    constructor() {
        super('/leadgen/save', '/leadgen/save-and-back');
    }

    on_save_success(response) {
        const modal = this.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        const modal_container = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.STEP_CONTAINER)
        const close_modal_button = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.CLOSE_BUTTON)
        const save_button = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.SAVE_BUTTON)
        const modal_content = response.html;

        this.enable_button(save_button)
        this.clear_invalid_feedbacks()

        if (response.tracking && response.tracking.google) {
            analytics ? analytics('event', response.tracking.google.type, response.tracking.google.data || undefined) : '';
        }

        if (typeof(fbq) == "function" && response.tracking && response.tracking.facebook) {
            fbq('track', response.tracking.facebook.type, response.tracking.facebook.data || undefined);
        }

        if (response.redirect_url) {
            close_modal_button.addClass('disabled')
            this.disable_button(save_button)
            save_button.html("Un momento... <i class=\"fa-solid fa-circle-notch fa-spin ms-2\"></i>")
            this.change_modal_container_content(modal_container, modal_content)

            setTimeout(function () {
                window.location.replace(response.redirect_url)
            }, 4000);

            return;
        }

        this.change_modal_container_content(modal_container, modal_content)
    }

    clear_invalid_feedbacks() {
        const modal = this.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        const invalid_feedbacks = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.INVALID_FEEDBACK)
        invalid_feedbacks.each((key, item) => {
            $(item).text("").hide()
        })
    }

    change_next_button_content(button, message) {
        button.html(message)
    }

    reset_next_button_content(button) {
        this.change_next_button_content(button, 'AVANTI')
    }

    save_and_next(element) {
        let $this = this;

        let modal = $this.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        let modal_save_button = $this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.SAVE_BUTTON)

        $this.disable_button(modal_save_button)

        let modal_step_container = $this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.STEP_CONTAINER)

        let append_inputs = [
            {
                name: 'step_info[product_id]',
                value: modal.data('product_id')
            },
            {
                name: 'step_info[course_id]',
                value: modal.data('course_id')
            },
            {
                name: 'step_info[product_price]',
                value: modal.data('product_price')
            },
            {
                name: 'step_info[product_list_price]',
                value: modal.data('product_list_price')
            },
        ];

        let form_data;
        let form = $this.get_step_container_form(modal_step_container);
        let step_name = $this.get_form_step_name(form);

        if (step_name === 'email') {
            const consents = this.get_modal_component(modal, '#modal_subscribe_check');
            let email_input = this.get_modal_component(modal, 'input[name="step_info[email]"]');
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(email_input.val()).toLowerCase())) {
                email_input.addClass('is-invalid')

                $this.enable_button(modal_save_button)
                return;
            }

            if (! consents.is(":checked")) {
                consents.addClass('is-invalid')
                $this.enable_button(modal_save_button)

                return;
            }

            append_inputs.push({name: 'email', value: email_input.val()})
            form_data = $this.get_modal_data_to_url(modal, modal_step_container, append_inputs)
            $this.change_next_button_content(modal_save_button, "AVANTI <i class=\"fa-solid fa-circle-notch fa-spin ms-2\"></i>")
            $this.send_form(this.save_url, form_data, (response) => this.on_save_success(response), () => this.on_save_error())

            return;
        }

        if (step_name === 'cellphone') {
            let phoneNumberInput = this.get_modal_component(modal, 'input[name="step_info[cellphone]"]');
            if (!phoneNumberInput.val()) {
                phoneNumberInput.addClass('is-invalid')
                this.get_modal_component(modal, '#cellphone-invalid-label').text('Inserisci un numero valido').show()
                this.enable_button(modal_save_button)
                return;
            }
            if (!phoneNumberInput.val() || !isValidPhoneNumber(phoneNumberInput.val())) {
                phoneNumberInput.addClass('is-invalid')
                this.get_modal_component(modal, '#cellphone-invalid-label').text('Inserisci un numero valido').show()
                this.enable_button(modal_save_button)
                return;
            }

            phoneNumberInput.removeClass('is-invalid')
            this.get_modal_component(modal, '#cellphone-invalid-label').hide()

            form_data = $this.get_modal_data_to_url(modal, modal_step_container, append_inputs)
            $this.change_next_button_content(modal_save_button, "AVANTI <i class=\"fa-solid fa-circle-notch fa-spin ms-2\"></i>")
            $this.send_form(this.save_url, form_data, (response) => this.on_save_success(response), () => this.on_save_error())

            return;
        }

        if (step_name === 'invest_in_courses') {
            $('#answers').addClass('d-none')
            $('#spinner').removeClass('d-none')
            append_inputs.push({name: 'step_info[invest_in_courses]', value: element.val()})
            form_data = $this.get_modal_data_to_url(modal, modal_step_container, append_inputs)
            $this.send_form(this.save_url, form_data, (response) => this.on_save_success(response), () => this.on_save_error())
            return;
        }

        if (step_name !== 'full_name' && step_name !== 'cellphone') {
            let data = this.get_modal_form_input(form, 'input[name="step_info[value]"]')
            let data_value = data.val();

            if (data.prop('type') === 'radio') {
                data_value = this.get_modal_form_input(form, 'input[name="step_info[value]"]:checked').val()
            }

            if (!data_value) {
                data.addClass('is-invalid')

                this.enable_button(modal_save_button)
                return;
            }
        }

        form_data = $this.get_modal_data_to_url(modal, modal_step_container, append_inputs)
        $this.change_next_button_content(modal_save_button, "AVANTI <i class=\"fa-solid fa-circle-notch fa-spin ms-2\"></i>")
        $this.send_form(this.save_url, form_data, (response) => this.on_save_success(response), () => this.on_save_error())
    }

    on_save_error () {
        let modal = this.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        let close_modal_button = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.CLOSE_BUTTON)
        let modal_save_button = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.SAVE_BUTTON)

        this.reset_next_button_content(modal_save_button)
        this.enable_button(modal_save_button)
        close_modal_button.removeClass('disabled')
    }

    save_and_back() {
        const modal = this.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        const modal_step_container = this.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.STEP_CONTAINER)
        const form_data = this.get_form_data(modal, modal_step_container)

        this.send_form(this.save_and_back_url, form_data, (response) => this.on_save_success(response))
    }
}

let blocca_offerta_leadgen_modal = new BloccaOffertaLeadgenModal();

$(document).ready(function () {

    var modal_save_button_identifier = BLOCCA_OFFERTA_LEADGEN_MODAL.ID + " " + BLOCCA_OFFERTA_LEADGEN_MODAL.SAVE_BUTTON;
    var modal_back_button_identifier = BLOCCA_OFFERTA_LEADGEN_MODAL.ID + " " + BLOCCA_OFFERTA_LEADGEN_MODAL.BACK_BUTTON;
    var modal_container_identifier = BLOCCA_OFFERTA_LEADGEN_MODAL.ID + " " + BLOCCA_OFFERTA_LEADGEN_MODAL.STEP_CONTAINER;
    var modal_check_input_identifier = modal_container_identifier + " " + BLOCCA_OFFERTA_LEADGEN_MODAL.CHECK_INPUT;
    var modal_leadgen_close = modal_container_identifier + " " + BLOCCA_OFFERTA_LEADGEN_MODAL.CLOSE;

    $(document).on('submit', '.leadgen-modal-form', function (event) {
        event.preventDefault()
        blocca_offerta_leadgen_modal.save_and_next()
    })

    $(document).on('click', modal_save_button_identifier , function (event) {
        var modal = blocca_offerta_leadgen_modal.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        var button = blocca_offerta_leadgen_modal.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.SAVE_BUTTON)
        blocca_offerta_leadgen_modal.disable_button(button)
        blocca_offerta_leadgen_modal.save_and_next()
    })

    $(document).on('click', modal_back_button_identifier, function () {
        blocca_offerta_leadgen_modal.save_and_back()
    })

    $(document).on('click', modal_check_input_identifier, function () {
        $(this).addClass('is-valid');
        if ($(this).data('submitter')) {
            blocca_offerta_leadgen_modal.save_and_next($(this))
        }
    })

    $(document).on('click', '#open-modal[data-modal=blocca_offerta]', function () {
        blocca_offerta_leadgen_modal.open_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
    })

    $(document).on('click', modal_leadgen_close, function (e) {
        e.preventDefault();
        var on_success = function (response) {
            var modal = blocca_offerta_leadgen_modal.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
            var modal_container = blocca_offerta_leadgen_modal.get_modal_component(modal, BLOCCA_OFFERTA_LEADGEN_MODAL.STEP_CONTAINER)
            blocca_offerta_leadgen_modal.change_modal_container_content(modal_container, response.html)

            if (response.finish) {
                blocca_offerta_leadgen_modal.close_modal()
            }
        }

        var modal = blocca_offerta_leadgen_modal.get_modal(BLOCCA_OFFERTA_LEADGEN_MODAL.ID)
        blocca_offerta_leadgen_modal.send_form(
            blocca_offerta_leadgen_modal.save_url,
            {close: 1, step: 'close', page_url: window.location.href, modal: blocca_offerta_leadgen_modal.get_modal_name(modal)},
            (response) => on_success(response)
        )
    })

    $(document).on('click', 'a[data-toggle]', function (e) {
        e.preventDefault();
        var toggle_id = $(this).data('toggle');
        var component_to_toggle = $("#"+toggle_id);
        component_to_toggle.toggleClass('hide')

        if (component_to_toggle.hasClass('hide')) {
            $(this).html("Più dettagli <i class=\"fa-solid fa-arrow-down\"></i>")
        } else {
            $(this).html("Riduci <i class=\"fa-solid fa-arrow-up\"></i>")
        }
    });
})
